/* Moin Mobile – Displayschutz-Finder  v2.1 – Cache-Bust 2026-09-15T2
 *
 * Suche laeuft ueber den getippten Modelltext; Hersteller und Ausfuehrung
 * filtern die Ergebnisse anschliessend im Browser.
 *
 * Abgleich ueber ganze Wortmarken, nicht ueber Teilstrings: "S22" darf kein
 * "A22" treffen. Nur das zuletzt getippte Wort darf ein Praefix sein.
 *
 * Zusammengeschriebene Eingaben wie "16pro" oder "iphone16pro" werden
 * erkannt. Fuer die Shopify-Suche wird die Eingabe entzerrt ("16 pro"), und
 * lokal greift zusaetzlich ein Vergleich ohne Leer- und Sonderzeichen.
 *
 * Fallback auf Universal-Produkt wenn kein passendes Produkt im
 * Katalog gefunden wird, kann der Kunde trotzdem bestellen. Das eingetippte
 * Modell wird als Bestell-Eigenschaft (Line Item Property) mitgeschickt.
 *
 * Notizfeld auf der Universal-Produktseite Kunde kann Hinweise hinterlassen.
 */
(function () {
  var UNIVERSAL_HANDLE = 'displayschutzfolie-individuelles-modell';
  var UNIVERSAL_URL    = '/products/' + UNIVERSAL_HANDLE;

  var BRANDS = {
    'Apple':   { any: ['iphone', 'ipad', 'apple watch', 'apple'], not: [] },
    'Samsung': { any: ['samsung', 'galaxy'], not: [] },
    'Xiaomi':  { any: ['xiaomi', 'poco'], not: ['redmi'] },
    'Redmi':   { any: ['redmi'], not: [] }
  };
  var KNOWN = ['iphone', 'ipad', 'apple', 'samsung', 'galaxy', 'xiaomi', 'poco', 'redmi'];

  function tokens(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[+]/g, ' plus ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(' ')
      .filter(Boolean);
  }

  function compact(s) {
    return String(s || '').toLowerCase().replace(/[+]/g, 'plus').replace(/[^a-z0-9]+/g, '');
  }

  function loosen(q) {
    return String(q || '')
      .replace(/(\d)([a-zA-Z])/g, '$1 $2')
      .replace(/([a-zA-Z]{3,})(\d)/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matchesModel(p, q) {
    var qt = tokens(loosen(q));
    if (!qt.length) return true;
    var tt = tokens(p.title);
    var ok = true;
    for (var i = 0; i < qt.length; i++) {
      var w = qt[i], last = (i === qt.length - 1), hit = false;
      for (var j = 0; j < tt.length; j++) {
        if (tt[j] === w || (last && tt[j].indexOf(w) === 0)) { hit = true; break; }
      }
      if (!hit) { ok = false; break; }
    }
    if (ok) return true;
    var cq = compact(q);
    return cq.length > 2 && compact(p.title).indexOf(cq) > -1;
  }

  function score(p, q) {
    return tokens(p.title).length - tokens(loosen(q)).length;
  }

  function parsePrice(v) {
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'number') return v / 100;
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function money(v) {
    var n = parsePrice(v);
    if (n === null) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return n.toLocaleString('de-DE', { style: 'currency', currency: cur });
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function cleanModelName(q) {
    var s = loosen(q).trim();
    return s.replace(/^(displayschutzfolie|schutzfolie|folie)\s+/i, '')
            .replace(/^\s+|\s+$/g, '')
            || s;
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var inp  = root.querySelector('[data-mmf-input]'),
        list = root.querySelector('[data-mmf-list]'),
        go   = root.querySelector('[data-mmf-go]'),
        hint = root.querySelector('[data-mmf-hint]');
    if (!inp || !list || !go) return;

    var brand = '', art = '', chosen = null, timer = null, idx = -1, items = [];

    root.querySelectorAll('[data-brand]').forEach(function (b) {
      b.addEventListener('click', function () {
        brand = (brand === b.dataset.brand) ? '' : b.dataset.brand;
        root.querySelectorAll('[data-brand]').forEach(function (x) {
          x.setAttribute('aria-pressed', (x.dataset.brand === brand && brand !== '') ? 'true' : 'false');
        });
        if (inp.value.trim().length > 1) run(inp.value); else inp.focus();
      });
    });

    root.querySelectorAll('[data-art]').forEach(function (b) {
      b.addEventListener('click', function () {
        art = (art === b.dataset.art) ? '' : b.dataset.art;
        root.querySelectorAll('[data-art]').forEach(function (x) {
          x.setAttribute('aria-pressed', x.dataset.art === art ? 'true' : 'false');
        });
        if (inp.value.trim().length > 1) run(inp.value);
      });
    });

    function matchesBrand(p) {
      if (!brand) return true;
      var hay = (p.title + ' ' + (p.vendor || '')).toLowerCase();
      var rule = BRANDS[brand];
      if (!rule) {
        return !KNOWN.some(function (k) { return hay.indexOf(k) > -1; });
      }
      if (rule.not.some(function (k) { return hay.indexOf(k) > -1; })) return false;
      return rule.any.some(function (k) { return hay.indexOf(k) > -1; });
    }

    function matchesArt(p) {
      return !art || p.title.toLowerCase().indexOf(art.toLowerCase()) > -1;
    }

    function renderFallback(q) {
      list.innerHTML = ''; items = []; idx = -1;
      var model = cleanModelName(q);

      var info = document.createElement('li');
      info.className = 'mvhf__empty';
      info.textContent = 'Kein exaktes Produkt gefunden – kein Problem:';
      list.appendChild(info);

      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.i = '0';
      li.style.cssText = 'background:#f0f7ff;border:1.5px solid #1b4b9b;border-radius:.5rem;margin-top:.25rem;';

      var icon = document.createElement('span');
      icon.textContent = '📱';
      icon.style.cssText = 'font-size:1.5rem;flex:0 0 auto;';
      li.appendChild(icon);

      var t = document.createElement('span');
      t.className = 'mvhf__t';
      t.innerHTML = '<strong>Folie für „' + model.replace(/</g,'&lt;') + '“ bestellen</strong>';
      li.appendChild(t);

      var pr = document.createElement('span');
      pr.className = 'mvhf__p';
      pr.textContent = 'ab 14,99 €';
      li.appendChild(pr);

      items = [{
        title: 'Displayschutzfolie – ' + model,
        url: UNIVERSAL_URL + '?model=' + encodeURIComponent(model),
        _universal: true
      }];

      li.addEventListener('click', function () { pick(0); });
      list.appendChild(li);

      list.hidden = false;
      inp.setAttribute('aria-expanded', 'true');
    }

    function render(ps, note) {
      list.innerHTML = ''; items = ps; idx = -1;
      if (!ps.length) {
        var q = inp.value.trim();
        if (q.length >= 2) {
          renderFallback(q);
          return;
        }
        var li = document.createElement('li');
        li.className = 'mvhf__empty';
        li.textContent = 'Kein Treffer – prüfe die Schreibweise oder lass die Filter weg.';
        list.appendChild(li);
        list.hidden = false; inp.setAttribute('aria-expanded', 'true');
        return;
      }
      if (note) {
        var n = document.createElement('li');
        n.className = 'mvhf__empty'; n.textContent = note;
        list.appendChild(n);
      }
      ps.forEach(function (p, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option'); li.dataset.i = i;
        if (p.featured_image && p.featured_image.url) {
          var im = document.createElement('img');
          im.src = p.featured_image.url;
          im.alt = ''; im.loading = 'lazy'; im.className = 'mvhf__thumb';
          li.appendChild(im);
        }
        var t = document.createElement('span'); t.className = 'mvhf__t'; t.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'mvhf__p';
        var val = (p.price_min !== undefined && p.price_min !== null) ? p.price_min : p.price;
        var m = money(val);
        pr.textContent = m ? ('ab ' + m) : '';
        li.appendChild(t); li.appendChild(pr);
        li.addEventListener('click', function () { pick(i); });
        list.appendChild(li);
      });
      list.hidden = false; inp.setAttribute('aria-expanded', 'true');
    }

    function pick(i) {
      chosen = items[i];
      var displayName = chosen.title
        .replace(/^(Displayschutzfolie|Displayschutzglas|Schutzglas)\s+[–—-]\s*/i, '')
        .replace(/^(Displayschutzfolie|Displayschutzglas|Schutzglas)\s+/i, '')
        .split(' – ')[0];
      inp.value = displayName;
      list.hidden = true;
      inp.setAttribute('aria-expanded', 'false');
      if (chosen._universal) {
        hint.textContent = '✅ Folie für „' + displayName + '“ – klicke auf den Button!';
      } else {
        hint.textContent = 'Ausgewählt: ' + chosen.title;
      }
    }

    function suggest(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=10' +
                '&resources[options][unavailable_products]=last';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
          return prods.filter(function (p) {
            return (p.handle || '').indexOf(UNIVERSAL_HANDLE) === -1;
          });
        })
        .catch(function () { return []; });
    }

    function run(q) {
      var raw = q.trim();
      var loose = loosen(raw);
      var calls = (loose !== raw) ? [suggest(loose), suggest(raw)] : [suggest(raw)];

      Promise.all(calls).then(function (sets) {
        var seen = {}, all = [];
        sets.forEach(function (set) {
          set.forEach(function (p) {
            var key = p.url || p.title;
            if (!seen[key]) { seen[key] = 1; all.push(p); }
          });
        });

        var f = all.filter(function (p) {
          return matchesBrand(p) && matchesArt(p) && matchesModel(p, raw);
        });
        f.sort(function (a, b) { return score(a, raw) - score(b, raw); });
        if (f.length) { render(f); return; }

        var m = all.filter(function (p) { return matchesModel(p, raw); });
        if (m.length) { render(m, 'Ohne deine Filter gibt es diese Treffer:'); return; }
        render([]);
      }).catch(function () { list.hidden = true; });
    }

    inp.addEventListener('input', function () {
      chosen = null;
      hint.textContent = 'Tippe dein Modell ein – Vorschläge erscheinen automatisch.';
      clearTimeout(timer);
      var v = inp.value.trim();
      if (v.length < 2) { list.hidden = true; inp.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(function () { run(v); }, 200);
    });

    inp.addEventListener('keydown', function (e) {
      if (list.hidden) { if (e.key === 'Enter') { e.preventDefault(); go.click(); } return; }
      var lis = list.querySelectorAll('li[role=option]');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!lis.length) return;
        idx = e.key === 'ArrowDown' ? Math.min(idx + 1, lis.length - 1) : Math.max(idx - 1, 0);
        lis.forEach(function (l, i) { l.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
        lis[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (idx > -1) pick(idx); else go.click();
      } else if (e.key === 'Escape') {
        list.hidden = true; inp.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { list.hidden = true; inp.setAttribute('aria-expanded', 'false'); }
    });

    go.addEventListener('click', function () {
      if (chosen && chosen.url) { window.location.href = chosen.url; return; }
      var q = inp.value.trim();
      if (!q) { window.location.href = '/collections/displayschutzfolie'; return; }
      window.location.href = UNIVERSAL_URL + '?model=' + encodeURIComponent(cleanModelName(q));
    });
  }

  function handleProductPageModel() {
    var params = new URLSearchParams(window.location.search);
    var model = params.get('model');
    if (!model) return;

    if (window.location.pathname.indexOf(UNIVERSAL_HANDLE) === -1) return;

    var titleEls = document.querySelectorAll('.product__title, h1.product-single__title, .product-title, [data-product-title], .content-for-layout h1, main h1');
    titleEls.forEach(function (el) {
      el.textContent = 'Displayschutzfolie ' + model;
    });
    document.title = 'Displayschutzfolie ' + model + ' | Moin Mobile';

    var forms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Modell]';
      hidden.value = model;
      form.appendChild(hidden);

      var wrap = document.createElement('div');
      wrap.style.cssText = 'margin:0 0 1.2rem;';

      var banner = document.createElement('div');
      banner.style.cssText = 'background:linear-gradient(135deg,#eef3fa,#f0f7ff);border:1.5px solid #1b4b9b;border-radius:.8rem;padding:1rem 1.2rem;display:flex;align-items:center;gap:.7rem;';
      banner.innerHTML = '<span style="font-size:1.6rem">📱</span>'
        + '<span style="font-size:.95rem;line-height:1.4"><strong>Dein Modell:</strong> '
        + model.replace(/</g, '&lt;')
        + '<br><span style="color:#5f6b76;font-size:.85rem">Wir schneiden die Folie passgenau für dieses Gerät zu.</span></span>';
      wrap.appendChild(banner);

      var noteWrap = document.createElement('div');
      noteWrap.style.cssText = 'margin-top:.8rem;';
      var noteLabel = document.createElement('label');
      noteLabel.setAttribute('for', 'mm-customer-note');
      noteLabel.style.cssText = 'display:block;font-size:.85rem;font-weight:600;margin-bottom:.3rem;color:#1b4b9b;';
      noteLabel.textContent = '📝 Hinweis / Notiz (optional)';
      noteWrap.appendChild(noteLabel);

      var noteField = document.createElement('textarea');
      noteField.id = 'mm-customer-note';
      noteField.name = 'properties[Kundennotiz]';
      noteField.rows = 2;
      noteField.placeholder = 'z. B. besondere Wünsche, genaue Modellbezeichnung, Farbe …';
      noteField.style.cssText = 'width:100%;border:1.5px solid #d0d5dd;border-radius:.6rem;padding:.6rem .8rem;font-size:.9rem;font-family:inherit;resize:vertical;transition:border-color .2s;';
      noteField.addEventListener('focus', function(){ noteField.style.borderColor='#1b4b9b'; });
      noteField.addEventListener('blur',  function(){ noteField.style.borderColor='#d0d5dd'; });
      noteWrap.appendChild(noteField);

      wrap.appendChild(noteWrap);
      form.insertBefore(wrap, form.firstChild);
    });
  }

  function boot() {
    document.querySelectorAll('[data-mmf-root]').forEach(init);
    handleProductPageModel();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
